import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const RecycleWindow = ({ isRecycleOpen, setIsRecycleOpen, zFILO, addToZFILO, removeFromZFILO }) => {
    const location = useLocation();
    const navigate = useNavigate();

    // Determine zIndex based on zFILO position
    const zIndex = zFILO.indexOf('recycle') !== -1 ? 1000 + zFILO.indexOf('recycle') : 1000;

    const handleClose = () => {
        setIsRecycleOpen(false);
        removeFromZFILO('recycle');
        navigate('/');
    };

    const handleMinimize = () => {
        setIsRecycleOpen(false);
        removeFromZFILO('recycle');
        navigate('/');
    };

    if (!isRecycleOpen) return null;

    return (
        <>
            <Helmet>
                <title>Recycle Bin | We Are A Site</title>
                <meta name="description" content="View deleted or archived pages from your WAAS desktop. Restore or permanently remove site files and components." />
            </Helmet>
            <div className='RecycleWindow DesktopWindow' style={{ zIndex }}>
                <div className='RecycleWindowTitleBar DesktopWindowTitleBar'>
                    <span className='Title'>Recycle Bin</span>
                    <div className='ResizeButtons'>
                        <img
                            src='/images/MinimizeIcon.png'
                            alt='Minimize'
                            className='MinimizeButton'
                            onClick={handleMinimize}
                        />
                        <img src='/images/MaximizeIcon.png' alt='Maximize' />
                        <img
                            src='/images/SystemMessageCloseButton.png'
                            alt='Close'
                            className='CloseButton'
                            onClick={handleClose}
                        />
                    </div>
                </div>
                <div>
                    Empty . . .
                </div>
            </div>
        </>
    );
};

export default RecycleWindow;
